import './Avatar.scss';
import React from 'react'
import { User } from '../models/User';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

type Props = {
  size?: 'sm' | 'md' | 'lg';
  user?: User;
  imageUrl?: string;
}

export default function Avatar({ size = 'md', user, imageUrl }: Props) {
  if (imageUrl) return <div className={`avatar ${size}`} style={{ backgroundImage: `url(${imageUrl})` }}></div>

  const initials = user ? user.firstname?.charAt(0) + user.lastname?.charAt(0) : null;

  return <div className={`avatar ${size}`}>{initials || <FontAwesomeIcon icon={solid('user')} />}</div>
}